import React, { Component } from 'react';
import classnames from 'classnames';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import RestClientParamsTab from '../../data-connector/postman/RestClientParamsTab';
import RestClientHeaderTab from '../../data-connector/postman/RestClientHeaderTab';
import CurrentUserParamRow from '../../data-connector/postman/CurrentUserParamRow';
import CustomRadio from '../../../common/ui/CustomRadio';
import CustomInputWithIconNoFormGroup from '../../../common/ui/CustomInputWithIconNoFormGroup';
import CustomSelect from '../../../common/formElements/CustomSelect';
export default class ExternalApiFormTabBar extends Component {
  static propTypes = {};
  state = {
    activeTab: '3',
  };

  toggle = (tab) => {
    this.setState({ activeTab: tab });
  };

  handleSelect = (selectedTab) => {
    this.setState({
      activeTab: selectedTab,
    });
  };

  handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    this.setState({ [name]: checked });
  };

  showCheckboxForLoggedInUser = () => {
    const { isDataFromLoginUser } = this.state;
    return (
      <div className="form-check">
        <label className="form-check-label">
          <input
            name="isDataFromLoginUser"
            type="checkbox"
            className="form-check-input"
            checked={isDataFromLoginUser}
            onChange={this.handleCheckboxChange}
          />
          Logged In User Data
          <span className="form-check-sign">
            <span className="check"></span>
          </span>
        </label>
        <small>( It will replace parameter from current logged in user )</small>
      </div>
    );
  };

  showCurrentUserField = () => {
    const { createNewParamRowForUser, currentUserParams } = this.props;
    const { isDataFromLoginUser } = this.state;
    if (!isDataFromLoginUser) {
      return '';
    }
    const { connectorType, externalapi } = this.props;
    const { collections, responseData } = externalapi;
    const userCollection = collections.find((collection) => collection.collectionName === 'user');
    if (!userCollection) {
      return 'No Login/Auth Plugin installed';
    }
    return (
      <div className="row p-2">
        <h4>
          <small>Current LoggedIn User Parameters</small>
        </h4>
        <table className="table table-sm table-borderless">
          <thead>
            <tr>
              <th width="30%">Key</th>
              <th width="70%">Value</th>
            </tr>
          </thead>
          <tbody>
            {currentUserParams.map((row) => {
              return (
                <CurrentUserParamRow
                  paramRow={row}
                  key={row.id}
                  userCollection={userCollection}
                  createNewParamRowForUser={createNewParamRowForUser}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    );
    // return 'Current LoggedIn User Field';
  };
  awsServiceOptions = [
    { label: 'Lambda', value: 'lambda' },
    { label: 'S3', value: 's3' },
    { label: 'EC2', value: 'ec2' },
    { label: 'DynamoDB', value: 'dynamodb' },
    { label: 'CloudWatch', value: 'cloudwatch' },
    { label: 'SNS', value: 'sns' },
    { label: 'API Gateway', value: 'api-gateway' },
    { label: 'IAM', value: 'iam' },
    { label: 'ECS', value: 'ecs' },
  ];
  render() {
    const {
      projectDetail,
      isAwsSignature,
      addAwsSignature,
      awsService,
      handleAWSCheckboxChange,
      handleAwsService,
    } = this.props;
    return (
      <>
        <Nav pills className="nav-pills-primary drapcode-nav-pills">
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '3' })}
              onClick={() => {
                this.toggle('3');
              }}
            >
              <i className="material-icons">article</i>
              Headers
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '1' })}
              onClick={() => {
                this.toggle('1');
              }}
            >
              <i className="material-icons">ballot</i>
              Params
            </NavLink>
          </NavItem>
          {/* <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '2' })}
              onClick={() => {
                this.toggle('2');
              }}
            >
              <i className="material-icons">account_circle</i>
              Authorization
            </NavLink>
          </NavItem> */}
        </Nav>

        <div className="col-12 px-4">
          <div className="card">
            <div className="card-body">
              <TabContent activeTab={this.state.activeTab}>
                <TabPane tabId="1">
                  <div className="row col-12">
                    <h4>
                      <small>Query Parameters</small>
                    </h4>
                  </div>
                  <RestClientParamsTab
                    createNewParamRow={this.props.createNewParamRow}
                    params={this.props.params}
                    externalapi={this.props.externalapi}
                    bodyDataFrom={this.props.bodyDataFrom}
                    collectionName={this.props.selectedCollectionName}
                    home={this.props.home}
                    projectDetail={projectDetail}
                  />
                </TabPane>
                {/* <TabPane tabId="2">
                  <div className="row">
                    <h4>
                      <small>
                        The authorization data will be automatically generated when you send the
                        request.
                      </small>
                    </h4>
                  </div>
                  <RestClientAuthTab
                    handleAuthData={this.props.handleAuthData}
                    authType={this.props.authType}
                    accessToken={this.props.accessToken}
                    requestHeader={this.props.requestHeader}
                  />
                </TabPane> */}
                <TabPane tabId="3">
                  <div className="row col-12">
                    <h4>
                      <small>Request Headers</small>
                    </h4>
                  </div>
                  {isAwsSignature && (
                    <div className="row col-12">
                      <div className="form-check col-6">
                        <CustomRadio label="Add AWS Signature headers" isRadio={false}>
                          <input
                            name="addAwsSignature"
                            type="checkbox"
                            className="form-check-input"
                            checked={addAwsSignature}
                            onChange={handleAWSCheckboxChange}
                          />
                        </CustomRadio>
                        <small>
                          (We will add AWS Signature headers in request and request body will be
                          base64 encoded.)
                        </small>
                      </div>
                      {addAwsSignature && (
                        <div className="col-6">
                          <CustomInputWithIconNoFormGroup
                            title="AWS Service"
                            icon="text"
                            required={true}
                            style="py-2"
                          >
                            <CustomSelect
                              name="awsService"
                              isMulti={false}
                              options={this.awsServiceOptions}
                              value={awsService}
                              onChange={(name, value) => handleAwsService(value)}
                              placeholder="Select AWS Service"
                            />
                          </CustomInputWithIconNoFormGroup>
                        </div>
                      )}
                    </div>
                  )}
                  <RestClientHeaderTab
                    headers={this.props.headers}
                    handleHeaderChange={this.props.handleHeaderChange}
                    externalapi={this.props.externalapi}
                    bodyDataFrom={this.props.bodyDataFrom}
                    collectionName={this.props.selectedCollectionName}
                    home={this.props.home}
                    projectDetail={projectDetail}
                  />
                </TabPane>
              </TabContent>
              {/* {this.showCheckboxForLoggedInUser()} */}
              {/* {this.showCurrentUserField()} */}
            </div>
          </div>
        </div>
      </>
    );
  }
}
